import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import nettestLogo from '../assets/nettestlogo.svg';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeSidebar = () => { setSidebarOpen(false); document.body.style.overflow = ''; };
  const openSidebar = () => { setSidebarOpen(true); document.body.style.overflow = 'hidden'; };

  const goHome = (hash = '') => {
    navigate('/');
    if (hash) setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  return (
    <>
      <header id="header" className={scrolled ? 'scrolled' : ''}>
        <div className="top-bar">
          <div className="container">
            <div className="contact-info">
              <a href="mailto:info@nettesttestere.com"><i className="fa-regular fa-envelope"></i> info@nettesttestere.com</a>
              <a href="https://wa.me/905470013478" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp"></i> 0547 001 34 78</a>
              
            </div>
            <div className="social-links">
              <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
              <a href="#"><i className="fa-brands fa-instagram"></i></a>
              <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
            </div>
          </div>
        </div>

        <nav className="navbar container">
          <Link to="/" className="brand-logo" onClick={() => window.scrollTo(0, 0)} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
            <img src={nettestLogo} alt="NetTest Testere" style={{ height: '70px', width: 'auto', display: 'block' }} />
            <h2 style={{ fontSize: '1.5rem', fontWeight: '900', margin: 0, letterSpacing: '-0.5px' }}>
              <span style={{ color: 'var(--primary)' }}>NETTEST</span>
              <span style={{ color: 'var(--secondary)', marginLeft: '0.3rem' }}>TESTERE</span>
            </h2>
          </Link>

          <div className="nav-links">
            <button className="nav-btn" onClick={() => goHome('#hero')}>Anasayfa</button>
            <button className="nav-btn" onClick={() => goHome('#about')}>Kurumsal</button>

            {/* Ürünler Dropdown */}
            <div className="dropdown">
              <button className="nav-btn">Ürünlerimiz <i className="fa-solid fa-chevron-down"></i></button>
              <div className="dropdown-content">
                <div className="dropdown-group">
                  <h4>Şerit Testereler</h4>
                  <Link to="/urunler/bimetal">Bimetal Şerit Testere</Link>
                  <Link to="/urunler/karbur">Karbür Şerit Testere</Link>
                  <Link to="/urunler/elmas-cbn">Elmas ve CBN Şerit Testere</Link>
                  <Link to="/urunler/karbon">Karbon Şerit Testere</Link>
                </div>
                <div className="dropdown-group">
                  <h4>Daire Testereler</h4>
                  <Link to="/urunler/daire-testere">Daire Testere</Link>
                </div>
              </div>
            </div>

            <div className="dropdown">
              <button className="nav-btn">Hizmetlerimiz <i className="fa-solid fa-chevron-down"></i></button>
              <div className="dropdown-content" style={{ minWidth: '250px' }}>
                <div className="dropdown-group">
                  <h4>Kaynak Testleri</h4>
                  <button className="dropdown-item-btn" onClick={() => goHome('#services')}>Tahribatsız Muayene (NDT)</button>
                  <button className="dropdown-item-btn" onClick={() => goHome('#services')}>Tahribatlı Testler</button>
                  <button className="dropdown-item-btn" onClick={() => goHome('#services')}>WPQR &amp; WPS İşlemleri</button>
                </div>
              </div>
            </div>

            <Link to="/blog" className="nav-btn">Blog</Link>

            <button className="btn-primary-sm" onClick={() => goHome('#contact')}>Teklif Alın</button>
          </div>

          <button className="menu-toggle" onClick={openSidebar} aria-label="Toggle Menu">
            <i className="fa-solid fa-bars"></i>
          </button>
        </nav>
      </header>

      {/* Mobil Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'active' : ''}`} id="sidebar">
        <div className="sidebar-header">
          <Link to="/" onClick={() => { goHome('#hero'); closeSidebar(); }} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
            <img src={nettestLogo} alt="NetTest Testere" style={{ height: '40px', width: 'auto', display: 'block' }} />
            <h2 style={{ fontSize: '1.1rem', fontWeight: '900', margin: 0, letterSpacing: '-0.5px' }}>
              <span style={{ color: 'var(--primary)' }}>NETTEST</span>
              <span style={{ color: 'var(--secondary)', marginLeft: '0.2rem' }}>TESTERE</span>
            </h2>
          </Link>
          <button className="close-sidebar" onClick={closeSidebar}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="sidebar-links">
          <button onClick={() => { goHome('#hero'); closeSidebar(); }}>Anasayfa</button>
          <button onClick={() => { goHome('#about'); closeSidebar(); }}>Kurumsal</button>
          <p style={{ fontWeight: 700, margin: '1.5rem 0 0.5rem', color: 'var(--primary)', fontSize: '0.8rem', textTransform: 'uppercase' }}>Şerit Testereler</p>
          <Link to="/urunler/bimetal" onClick={closeSidebar}>Bimetal Şerit Testere</Link>
          <Link to="/urunler/karbur" onClick={closeSidebar}>Karbür Şerit Testere</Link>
          <Link to="/urunler/elmas-cbn" onClick={closeSidebar}>Elmas &amp; CBN Şerit Testere</Link>
          <Link to="/urunler/karbon" onClick={closeSidebar}>Karbon Şerit Testere</Link>
          <p style={{ fontWeight: 700, margin: '1.5rem 0 0.5rem', color: 'var(--primary)', fontSize: '0.8rem', textTransform: 'uppercase' }}>Daire Testereler</p>
          <Link to="/urunler/daire-testere" onClick={closeSidebar}>Daire Testere</Link>
          <Link to="/blog" onClick={closeSidebar}>Blog / Rehber</Link>
          <button className="btn-primary-sm" style={{ marginTop: '2rem', width: '100%', textAlign: 'center' }}
            onClick={() => { goHome('#contact'); closeSidebar(); }}>
            Teklif Alın
          </button>
        </div>
      </div>
      <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
    </>
  );
};

export default Header;
